<!--
    Program: NoticeDetail.vue
    Author: SDL
    Description: 
    Created: 2020.03.13
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">Notice View</h2>
            <!-- breadcrumbs -->
            <!-- //breadcrumbs -->
            <!-- //contents_head -->
            <!-- detail_f tit -->
            <div class="sub_tit">Basic Info.</div>
            <!-- //detail_f tit -->
            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Date</th>
                        <td>{{view.reg_dt}}</td>
                        <th>Register</th>
                        <td>{{view.reg_user_id}}</td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td>{{view.type1}} </td>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr>
                        <th>Title</th>
                        <td colspan="3">{{view.title}}</td>
                    </tr>
                    <tr>
                        <th>Contents</th>
                        <td colspan="3">
                            <span v-html="view.content"></span>
                            <!-- <cross-editor-viewer
                                :editorId="'editorId-'+view.seq"
                                :editorData="view.content || getBlankTemplate"
                            /> -->
                        </td>
                    </tr>
                    <tr>
                        <th>Attachment</th>
                        <td colspan="3" class="no_padding">
                            <innorix-download
                                v-if="fileList.length > 0"
                                :id="view.seq"
                                :name="view.seq" 
                                :uploadId="view.seq"
                                serviceType="common"
                                :attachList="fileList"
                                :seq="view.seq"
                            />
                            <span v-else>
                                No Attachment
                            </span>
                            <!-- <div class="attachment_wrap">
                            <img src="images/@attachment.png" alt />
                            </div>-->

                            <dl class="attachment_link" v-if="fileList.length > 0">
                                <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                                <dd>
                                    <ul>
                                        <li v-for="file in fileList" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                            <!-- <a :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" download="true" target="_blank" class="txt_link"> -->
                                            <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                <span class="ico_attach"></span> {{ file.FILE_NM }}
                                            </a>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white" title @click="onBackToListClick">List</a>
                <div v-if="['A16', 'S05'].includes(roleCd)" class="btn_right">
                    <fragment>
                        <a
                            href="javascript:"
                            v-if="roleCd === 'S05'"
                            class="btn_white"
                            @click="onEditClick"
                        >Edit</a>
                        <a
                            href="javascript:"
                            v-if="roleCd === 'S05'"
                            class="btn_white"
                            @click="onDeleteClick"
                        >Delete</a>
                    </fragment>
                    <a href="javascript:" class="btn_blue" @click="onTranslateClick">Translate</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import qs from 'query-string';

import store from '@/vuex/store';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';

import InnorixDownload from '~c/InnorixDownload';

export default {
    name: 'hhp-bulletin-view',
    components: {
        'innorix-download': InnorixDownload,
    },
    props: {
        seq: {
            type: String,
            required: false,
        },
        onBackToList: {
            type: Function,
            required: false,
        },
        // encToken: {
        //     type: String,
        //     required: true,
        // },
    },
    computed: {
        getBlankTemplate() {
            return BlankPageTempPage;
        },
    },
    data() {
        return {
            roleCd: '',
            view: {},
            countryList: [],
            userLevelList: [],
            fileList: [],
            encToken: '',

            delAttachFiles: [],
            isRemove: false,
        };
    },
    created() {
        console.log('Component: created. SEQ: ',  this.seq);
        this.init();
    },
    mounted() {
        console.log('Component:  mounted.');
    },
    methods: {
        async init() {
            const data = await this.fetchData();
            this.setData(data);
            // this.setUserList(data.userLevelList, );
        },

        fetchData() {
            const params = {
                seq: this.seq,
            };

            const path = '/basis/anysvcmobile/notice/noticeView.skp';
            return SDLUtil.getRequest(path, params);
            // return (
            //     axios
            //         // Loads data such as list of countries, etc...
            //         .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbView.skp`, { params })
            //         .then(res => {
            //             console.log('SvcBulletin RESPONSE', res);
            //             // res.data.rows => [['CODE_NAME', 'CODE_ID'], ...]
            //             // console.log('LOG', this.availableParentCodeList);
            //             return res.data;
            //         })
            //     // .catch(err => {
            //     //     console.log(`SvcBulletin ERROR =>>`, err);
            //     //     return res.data;
            //     // })
            // );
        },

        setData(data) {
            //this.roleCd = data.roleCd;

            this.view = data.view;
            // this.view.tran = data.view.tran.replace(',', ''); // replace the first comman.
            this.view.content = SDLUtil.stripHtml(data.view.content);

            this.encToken = data.encToken;
            this.fileList = data.fileBox.map(item => {
                item.seq = this.view.seq;
                return item;
            });
            console.log('fileList', this.fileList);

            // console.log('this.view.tran', this.view.tran);
            this.countryList = data.country.map(item => item.COUNTRY_NM).sort();
            // console.log('countryList', this.countryList);
            this.userLevelList = data.userLevelList.map(item => {
                const matched = data.userLevelLabelList.find(i => i.CODE_ID === item.USER_LEVEL);
                return {
                    CODE_ID: item.USER_LEVEL,
                    CODE_NAME: matched ? matched.CODE_NAME : '',
                };
            });
            console.log('userLevelList', this.userLevelList);
        },

        // setUserLevelList(list) {},

        // setCountryList(list) {},

        onEditClick() {
            this.$router.push({
                name: 'hhpServiceBulletinEdit',
                query: {
                    seq: this.seq,
                },
            });
        },

        onDeleteClick() {
            const onOkEvt = async () => {
                const data = await this.deleteContent();
                SDLUtil.alert({
                    title: 'Deleted!',
                    msg: data.message,
                    onOkEvt: () => this.onBackToListClick(),
                });
            };

            SDLUtil.confirm({
                title: 'Confirm',
                msg: 'Want to Delete?',
                okLabel: 'Delete',
                cancelLabel: 'No',
                onOkEvt,
            });
        },

        onTranslateClick() {
            this.$router.push({
                name: 'hhpServiceBulletinTranslate',
                query: {
                    seq: this.seq,
                },
            });
        },

        onBackToListClick() {
            this.$router.push({
                name: 'anysvcNotice',
            });
        },

        deleteContent() {
            const params = {
                seq: this.seq,
            };
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbDeleteProc.skp`,
                        { params })
                    .then(res => {
                        console.log('SvcBulletin DELETE', res);
                        // res.data.rows => [['CODE_NAME', 'CODE_ID'], ...]
                        // console.log('LOG', this.availableParentCodeList);
                        return res.data;
                    })
                // .catch(err => {
                //     console.log(`SvcBulletin ERROR =>>`, err);
                //     return res.data;
                // })
            );

        },

        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixDownload.vue -> BulletinView.vue / files : ', val);
            this.fileList = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },

        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },

        getDownloadUrl(SEQ, TOKEN) {
            const params = {
                attachFileSeq: SEQ,
                encToken: TOKEN,
                anysvc: 'Y',
                seq: this.view.seq,
            };

            this.increaseHhpDownloadCount(this.view.seq);

            const downloadUrl = `${SDLUtil.API_URL}/basis/common/attachBulletinDownload.skp?${qs.stringify(params)}`;
            return window.open(downloadUrl);
        },

        increaseHhpDownloadCount(seq) {
            const hhpSvcDownloadCountApi = `${SDLUtil.API_URL}/basis/common/attachBulletinDownloadCount.skp?${qs.stringify({seq:seq})}`; // POST
            return axios.post(hhpSvcDownloadCountApi);
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/notice/NoticeDetail.vue